import React from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { Button } from "@mui/material";
import { SideMenu, BackHeader } from "./../../components";
import { useNavigate, useLocation } from "react-router-dom";
let CreateNewInvoice = () => {
  const navigate = useNavigate();
  const location = useLocation();
  return (
    <SideMenu>
      <div className="page-container">
        <BackHeader backHanler={() => navigate(-1)} />
        <p className="page-form-heading">
          {location.state.type === "add"
            ? "Create new invoice"
            : "Edit  invoice"}
        </p>
        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={2}>
            <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
              <div>
                <p className="input-heading">Student name</p>
                <input
                  type="text"
                  className="input"
                  placeholder="Enter student name"
                />
              </div>
            </Grid>
          </Grid>
          <Grid container spacing={2}>
            <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
              <div>
                <p className="input-heading">Invoice ID</p>
                <input
                  type="number"
                  className="input"
                  placeholder="Invoice ID"
                />
              </div>
            </Grid>
            <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
              <div>
                <p className="input-heading">Order number</p>
                <input
                  type="number"
                  className="input"
                  placeholder="Order number"
                />
              </div>
            </Grid>
          </Grid>
          <Grid container spacing={2}>
            <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
              <div>
                <p className="input-heading">Invoice Date</p>
                <input type="date" className="input" />
              </div>
            </Grid>
            <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
              <div>
                <p className="input-heading">Due date</p>
                <input type="date" className="input" />
              </div>
            </Grid>
          </Grid>
          <Grid container spacing={2}>
            <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
              <div>
                <p className="input-heading">Description</p>
                <textarea
                  className="textarea"
                  placeholder="Enter your student know what this invoice is for"
                  rows="20"
                  cols="40"
                ></textarea>
              </div>
            </Grid>
          </Grid>
          <br />
          <div className="table-data-container">
            <table className="create-invoice-table">
              <tr>
                <th className="create-invoice-table-title-heading">Title</th>
                <th className="create-invoice-table-date-heading">
                  Start date - End date
                </th>
                <th className="create-invoice-table-rate-heading">Rate</th>
                <th className="create-invoice-table-tax-heading">Tax</th>
                <th className="create-invoice-table-amount-heading">Amount</th>
              </tr>
              <tr>
                <td className="create-invoice-table-monthly-fees">
                  Monthly student Fee
                </td>
                <td className="create-invoice-table-data">
                  08/03/2022 - 08/04/2022
                </td>
                <td className="create-invoice-table-data">1099</td>
                <td className="create-invoice-table-data">
                  Service tax (5%)(5%)
                </td>
                <td className="create-invoice-table-data">1099</td>
              </tr>
              <tr>
                <td className="create-invoice-table-payment-main" rowSpan={4}>
                  <Button>
                    <p className="create-invoice-table-link">
                      + add another line
                    </p>
                  </Button>
                </td>
                <td className="create-invoice-table-sub-heading">Sub Totle</td>
                <td className="create-invoice-table-empty"></td>
                <td className="create-invoice-table-empty"></td>
                <td className="create-invoice-table-price">1099</td>
              </tr>
              <tr>
                <td className="create-invoice-table-sub-heading">Discount</td>
                <td className="create-invoice-table-empty" colSpan={2}>
                  <div className="country-code-picker-main">
                    <div className="country-code-picker-dropdown-main">
                      <select className="country-code-picker-dropdown">
                        <option value="$">$</option>
                        <option value="£">£</option>
                        <option value="€">€</option>
                      </select>
                    </div>
                    <div className="country-flag-main">
                      <input
                        type="number"
                        className="mobile-number-input"
                        placeholder=""
                      />
                    </div>
                  </div>
                </td>
                <td className="create-invoice-table-price">-10</td>
              </tr>
              <tr>
                <td className="create-invoice-table-sub-heading">
                  Service Tax (5%)
                </td>
                <td className="create-invoice-table-empty"></td>
                <td className="create-invoice-table-empty"></td>
                <td className="create-invoice-table-price">119.65</td>
              </tr>
              <tr>
                <td className="create-invoice-table-total-heading">Total</td>
                <td className="create-invoice-table-empty"></td>
                <td className="create-invoice-table-empty"></td>
                <td className="create-invoice-table-total-price">1208.65</td>
              </tr>
            </table>
          </div>

          <Grid container spacing={2}>
            <Grid item xl={3} lg={3} md={3} sm={12} xs={12}></Grid>
            <Grid item xl={3} lg={3} md={3} sm={12} xs={12}>
              <Button
                className="form-button"
                variant="text"
                onClick={() => navigate("/invoice/preview")}
              >
                Preview
              </Button>
            </Grid>
            <Grid item xl={3} lg={3} md={3} sm={12} xs={12}>
              <Button
                className="form-button"
                variant="text"
                onClick={() => navigate(-1)}
              >
                Save & Continue
              </Button>
            </Grid>
            <Grid item xl={3} lg={3} md={3} sm={12} xs={12}></Grid>
          </Grid>
        </Box>
      </div>
    </SideMenu>
  );
};
export default CreateNewInvoice;
